import { Component, Input, OnInit } from '@angular/core';
import { CampanhaSearch } from '../../../campanha-search';
import { isStatusNaoConfirmada, isStatusEmAnalise, isStatusReprovada, isStatusEmAndamento, isStatusEncerrada, isStatusEmRevisao } from '../../../status';

interface Config {
    isNaoConfirmada: boolean;
    isEmAnalise: boolean;
    isReprovada: boolean;
    isEmAndamento: boolean;
    isEmRevisao: boolean;
    isEncerrada: boolean;
}

@Component({
    selector: 'sgt-campanha-pipeline-card-info-status',
    templateUrl: './campanha-pipeline-card-info-status.component.html',
    styleUrls: ['./campanha-pipeline-card-info-status.component.less']
})
export class CampanhaPipelineCardInfoStatusComponent implements OnInit {
    config: Config;
    @Input() campanha: CampanhaSearch;

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        if (!this.campanha) {
            return;
        }

        this.config = {
            isNaoConfirmada: isStatusNaoConfirmada(this.campanha.status),
            isEmAnalise: isStatusEmAnalise(this.campanha.status),
            isReprovada: isStatusReprovada(this.campanha.status),
            isEmAndamento: isStatusEmAndamento(this.campanha.status),
            isEmRevisao: isStatusEmRevisao(this.campanha.status),
            isEncerrada: isStatusEncerrada(this.campanha.status)
        };
    }
}
